const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");

const isLocalHostname = () => {
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
};

export const getConfiguredServerBaseUrl = () => {
  const explicit = trimTrailingSlash(process.env.REACT_APP_SERVER_URL);
  if (explicit) {
    return explicit;
  }

  const loginUrl = trimTrailingSlash(process.env.REACT_APP_LOGIN_URL);
  if (loginUrl) {
    return loginUrl.replace(/\/login$/i, "");
  }

  return "";
};

export const getLocalServerBaseUrl = () =>
  trimTrailingSlash(process.env.REACT_APP_LOCAL_SERVER_URL) || "http://127.0.0.1:8080";

export const getServerBaseUrl = () =>
  isLocalHostname() ? getLocalServerBaseUrl() : getConfiguredServerBaseUrl();

export const buildServerUrl = (path = "") => {
  const baseUrl = getServerBaseUrl();
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
};

export const getServerUrlCandidates = (path = "") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  if (isLocalHostname()) {
    return [`${getLocalServerBaseUrl()}${normalizedPath}`];
  }

  const urls = [];
  const configured = getConfiguredServerBaseUrl();
  if (configured) {
    urls.push(`${configured}${normalizedPath}`);
  }

  return [...new Set(urls)];
};
